module.exports = __webpack_public_path__ + "img/ajax-loader.77d1993d.gif";